// src/blocks/move/moveForward/.ts

import * as Blockly from "blockly";
import { javascriptGenerator } from "blockly/javascript";
import { BlocklyFields } from "../../BlocklyFields";
import i18next from "i18next";

export function initMoveForwardBlock() {
  Blockly.Blocks[BlocklyFields.MOVE_FORWARD] = {
    init: function () {
      this.jsonInit({
        type: BlocklyFields.MOVE_FORWARD,
        message0:
          "%1 " + i18next.t("blockly.move.forward.message", "Move forward"),
        args0: [
          {
            type: "field_image",
            src: "/images/blocks/forward.png",
            width: 16, // Largeur de l'image
            height: 16, // Hauteur de l'image
          },
        ],
        previousStatement: null,
        nextStatement: null,
        colour: "#FFAB19", // Rose, par exemple
        tooltip: i18next.t("blockly.move.forward.tooltip", ""),
        helpUrl: "",
      });
    },
  };

  javascriptGenerator.forBlock[BlocklyFields.MOVE_FORWARD] = function (
    block,
    generator
  ) {
    return "await moveForward();\n";
  };
}
